/* eslint-disable no-undef */
const useLinks = () => {
  const linkImage = process.env.REACT_APP_NOT_SECRET_CODE + "images/";
  return linkImage;
};

export default useLinks;
